import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PreventBack = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname === "/CustomerServiceOrder") {
      window.history.pushState(null, "", window.location.href);
      const handleBackButton = () => {
        window.history.pushState(null, "", window.location.href);
      };
      window.addEventListener("popstate", handleBackButton);
      return () => {
        window.removeEventListener("popstate", handleBackButton);
      };
    }
  }, [location]);
  return null; 
};

export default PreventBack;